import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 物业管理公司信息维护
 */
export class PropertyMgeInfoControllerSvr {
    constructor() {
        this.baseurl = 'PropertyMgeInfoControllerSvr.assx/';
    }

    /**
     * 添加物业企业信息
     * token:String, realtyMgeCom:RealtyMgeCom
     */
    AddPropertyMgeInfo(token, realtyMgeCom) {
        return request.post(this.baseurl + 'AddPropertyMgeInfo', Qs.stringify({
            token: token,
            realtyMgeCom: typeof realtyMgeCom === 'undefined' || realtyMgeCom === null ? '' : realtyMgeCom.toString()
        }));
    }

    /**
     * 获取物业企业
     * token:String, orgCode:String
     */
    GetproPertyMgeInfo(token, orgCode) {
        return request.post(this.baseurl + 'GetproPertyMgeInfo', Qs.stringify({
            token: token,
            orgCode: orgCode
        }));
    }

    /**
     * 编辑物业企业信息
     * token:String, realtyMgeCom:RealtyMgeCom
     */
    ModifyPropertyMgeInfo(token, realtyMgeCom) {
        return request.post(this.baseurl + 'ModifyPropertyMgeInfo', Qs.stringify({
            token: token,
            realtyMgeCom: typeof realtyMgeCom === 'undefined' || realtyMgeCom === null ? '' : realtyMgeCom.toString()
        }));
    }

    /**
     * 查询物业企业信息列表
     * token:String, orgCode:String, orgName:String, startIndex:int, maxSize:int
     */
    GetPropertyMgeInfoList(token, orgCode, orgName, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetPropertyMgeInfoList', Qs.stringify({
            token: token,
            orgCode: orgCode,
            orgName: orgName,
            startIndex: startIndex,
            maxSize: maxSize
        }));
    }

    /**
     * 删除物业企业信息
     * token:String, orgCode:String
     */
    DetelyPropertyMgeInfo(token, orgCode) {
        return request.post(this.baseurl + 'DetelyPropertyMgeInfo', Qs.stringify({
            token: token,
            orgCode: orgCode
        }));
    }
}